<template>
	<div class="container">
		<div class="col-md-12">
			<h3><b><i>{{ f_titulo() }}</i></b></h3>
		</div>

		<b-container>
			<b-row class="mb-4 align-items-center text-lg">
				<!-- Vigencia -->
				<b-col md="4">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.vigencia }}</b></label>
					<input type="month" v-model="selVigencia" class="form-control form-control-lg">
				</b-col>

				<!-- Grupo -->
				<b-col md="4">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.group }}</b></label>
					<select v-model="grupoId" @change="f_filterCompany" class="form-control form-control-lg">
						<option value="">Todos los grupos</option>
						<option v-for="grupo in listGrupos" :key="grupo.id" :value="grupo.id">
							{{ grupo.nombre }}
						</option>
					</select>
				</b-col>

				<!-- Compañía -->
				<b-col md="4">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.company }}</b></label>
					<select v-model="companyId" @change="f_valide_formato_interco" class="form-control form-control-lg">
						<option value="">{{ labels.seleccione }}</option>
						<option v-for="company in filteredCompany" :key="company.id" :value="company.id">
							{{ company.acronym }} - {{ company.nombre }}
							<span v-if="company.formato_interco">(Formato: {{ company.formato_interco }})</span>
						</option>
					</select>
				</b-col>
			</b-row>

			<b-row v-if="selVigencia && companyId && formato_interco_asignado" class="mb-4 align-items-center text-lg">
				<b-col md="6">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>Archivo Excel</b></label>
					<input id="archivoExcel" type="file" @change="cargaExcel()" class="form-control form-control-lg"
						accept=".xlsx, .xls">

					<!--  LOADER MEJORADO -->
					<div v-if="isLoading" class="mt-3 p-3 border rounded bg-light">
						<div class="text-center">
							<b-spinner variant="primary" class="mb-2"></b-spinner>
							<p class="mb-0 text-primary font-weight-bold">Procesando archivo...</p>
							<small class="text-muted">Por favor espere</small>
						</div>
					</div>
				</b-col>

				<b-col v-if="muestraHoja" md="6">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.hoja }}</b></label>
					<select v-model="selectedHoja" @change="f_showHoja()" class="form-control form-control-lg">
						<option value="">{{ labels.seleccione }}</option>
						<option v-for="(item, idx) in listHojas" :value="item" :key="idx">{{ item }}</option>
					</select>
				</b-col>
			</b-row>
		</b-container>

		<div class="col-md-1"></div>
		<div v-if="showBtnHoja == true" class="col-md-12 row justify-content-center mt-4">
			<!-- MODIFICADO: Llamar al método showConfirmationModal() -->
			<b-button @click="showConfirmationModal()" id="consult-btn">{{ labels.chargeHoja }}</b-button>
		</div>

		<!-- NUEVO: MODAL DE CONFIRMACIÓN -->
		<b-modal v-model="showConfirmModal" title="Confirmar Carga de Archivo" hide-footer centered no-close-on-backdrop
			no-close-on-esc @hidden="onConfirmModalHidden">
			<div class="text-center">
				<!-- Información de la carga -->
				<div class="confirmation-info mb-4">
					<p><strong>Fecha seleccionada:</strong> {{ formatFecha(selVigencia) }}</p>
					<p><strong>Compañía:</strong> {{ getCompanyName() }}</p>
					<p><strong>Archivo:</strong> {{ getFileName() }}</p>
					<p><strong>Hoja seleccionada:</strong> {{ selectedHoja }}</p>
					<p v-if="formato_interco_nombre"><strong>Formato:</strong> {{ formato_interco_nombre }}</p>
				</div>

				<!-- Mensaje de advertencia -->
				<div class="alert alert-warning" role="alert">
					<i class="fas fa-exclamation-triangle"></i>
					Por favor verifique que la fecha sea correcta. Esta acción no se puede deshacer.
				</div>

				<!-- Botones -->
				<div class="mt-4">
					<b-button @click="confirmAndLoad()" variant="primary" :disabled="!confirmButtonEnabled"
						:class="{ 'btn-secondary': !confirmButtonEnabled }" size="lg" block>
						{{ confirmButtonEnabled ? 'Aceptar y Cargar' : `Esperar ${countdown} segundos` }}
					</b-button>
					<b-button @click="cancelConfirmation()" variant="outline-secondary" block class="mt-2">
						Cancelar
					</b-button>
				</div>
			</div>
		</b-modal>

		<!-- Modal de Progreso MEJORADO - SIN BARRA DE PROGRESO -->
		<b-modal v-model="showProgressModal" title="Procesando Archivo" hide-footer centered no-close-on-backdrop
			no-close-on-esc>
			<div class="text-center">
				<!-- Spinner -->
				<b-spinner variant="primary" style="width: 3rem; height: 3rem;" class="mb-3"></b-spinner>

				<!-- Información del Proceso -->
				<h5 class="mb-3">Procesando archivo Excel</h5>

				<!-- Progreso por Etapas -->
				<div class="progress-stages mb-3">
					<div class="stage" :class="{ 'active': progressPercentage >= 0 }">
						<div class="stage-indicator">1</div>
						<span class="stage-label">Preparando datos</span>
					</div>
					<div class="stage" :class="{ 'active': progressPercentage >= 30 }">
						<div class="stage-indicator">2</div>
						<span class="stage-label">Enviando al servidor</span>
					</div>
					<div class="stage" :class="{ 'active': progressPercentage >= 60 }">
						<div class="stage-indicator">3</div>
						<span class="stage-label">Procesando</span>
					</div>
					<div class="stage" :class="{ 'active': progressPercentage >= 100 }">
						<div class="stage-indicator">4</div>
						<span class="stage-label">Completado</span>
					</div>
				</div>

				<!-- Detalles del Progreso MEJORADOS -->
				<div class="progress-details">
					<p class="mb-2"><strong>Estado: {{ getProgressStage() }}</strong></p>
					<p class="mb-2">Filas procesadas: {{ processedRows }} de {{ totalRows }}</p>
					<p class="mb-0">Tiempo transcurrido: {{ elapsedTime }}</p>
				</div>

				<!-- Botón de Cancelar -->
				<b-button @click="cancelUpload" variant="outline-danger" class="mt-3">
					Cancelar Proceso
				</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Company from "../../services/Company"
import Cargue from "../../services/Cargue";
import * as XLSX from "xlsx"
import Grupo from "../../services/Grupo"

export default {
	name: "CargueInterco",
	data: () => ({
		listGrupos: [],
		grupoId: "",
		filteredCompany: [],
		listCompany: [],
		listFormatos: [], // AÑADIDO: lista de formatos
		listVigencia: [],
		companyId: "",
		selVigencia: "",
		formato_interco_asignado: false,
		formato_interco: '',
		formato_interco_nombre: '',
		companyName: '',
		listCuenta: [],
		listHojas: [],
		showBtnHoja: false,
		isLoading: false,
		inputArch: "",
		workbook: "",
		muestraHoja: false,
		selHoja: false,
		selectedHoja: '',
		fileReader: '',

		// Variables para el progreso
		showProgressModal: false,
		progressMessage: '',
		progressPercentage: 0,
		currentLote: 0,
		totalLotes: 0,
		processedRows: 0,
		totalRows: 0,
		startTime: null,
		elapsedTime: '0s',
		progressInterval: null,
		isUploadCancelled: false,

		// NUEVAS VARIABLES PARA MODAL DE CONFIRMACIÓN
		showConfirmModal: false,
		confirmButtonEnabled: false,
		countdown: 5,
		countdownInterval: null,
		fileName: ''
	}),
	computed: {
		labels() {
			if (this.$store.state._language == "es-ES") {
				return {
					title: "CARGUE SALDOS INTERCOMPAÑÍAS",
					company: "Compañía:",
					group: "Grupo",
					vigencia: "Vigencia:",
					charge: "Cargar",
					chargeHoja: "Cargar Hoja",
					seleccione: "Seleccione.....",
					hoja: "Hoja"
				}
			} else {
				return {
					title: "LOAD INTERCOMPANY BALANCES",
					company: "Company:",
					group: "Group",
					vigencia: "Validity:",
					charge: "Charge",
					chargeHoja: "Charge Sheet",
					seleccione: "Select.....",
					hoja: "Sheet"
				}
			}
		}
	},
	methods: {
		f_titulo() {
			let titulo = "PROCESO DE CARGUE DE BALANCES POR INTERCOMPAÑÍAS"
			let tituloEN = "INTERCOMPANY BALANCES UPLOAD PROCESS"
			if (this.$store.state._language != "es-ES") {
				titulo = tituloEN
			}
			return titulo
		},

		f_filterCompany() {
			console.log('=== INICIO FILTRO INTERCO ===');
			console.log('Grupo seleccionado (ID):', this.grupoId);

			if (this.grupoId) {
				const grupoIdNum = this.grupoId.toString();
				this.filteredCompany = this.listCompany.filter(company => {
					if (!company.id_grupos) return false;
					const gruposCompania = company.id_grupos.split(',').map(id => id.trim());
					return gruposCompania.includes(grupoIdNum);
				});
			} else {
				this.filteredCompany = this.listCompany;
			}

			this.companyId = "";
			this.formato_interco_asignado = false;
		},

		f_valide_formato_interco() {
			this.formato_interco_asignado = false;
			let objCompany = this.listCompany.find((obj) => obj.id === this.companyId);

			if (objCompany) {
				this.companyName = objCompany.nombre;
				let formatoObj = this.listFormatos.find(f =>
					parseInt(f.id_compania) === parseInt(this.companyId)
				);

				if (formatoObj && formatoObj.formato_interco) {
					this.formato_interco = formatoObj.formato_interco.toString();
					this.formato_interco_asignado = true;
					this.formato_interco_nombre = this.obtenerNombreFormato(this.formato_interco);
					console.log('Formato interco asignado:', this.formato_interco, typeof this.formato_interco);
				}
			}
		},

		obtenerNombreFormato(codigo) {
			const formatos = {
				'1': 'Formato Básico [Cuenta, NIT, Saldo]',
				'2': 'Formato Columnas Fijas',
				'3': 'Formato Combinado [Cuenta-NIT, Saldo]',
				'auto': 'Detección Automática'
			};
			return formatos[codigo] || `Formato ${codigo}`;
		},

		cargaExcel() {
			this.showBtnHoja = false;
			this.muestraHoja = false;
			this.selHoja = false;
			this.selectedHoja = '';

			//  ACTIVAR LOADER
			this.isLoading = true;

			const inputArch = document.getElementById("archivoExcel");
			var selectedFile = inputArch.files[0];

			// NUEVO: Guardar nombre del archivo
			this.fileName = selectedFile ? selectedFile.name : '';

			//  LIMPIAR SELECTOR DE HOJAS SI HABÍA UN ARCHIVO PREVIO
			this.listHojas = [];

			this.fileReader = new FileReader();

			this.fileReader.onload = (event) => {
				var data = event.target.result;

				//  USAR setTimeout PARA NO BLOQUEAR LA INTERFAZ
				setTimeout(() => {
					try {
						console.log("🔄 Procesando estructura del archivo Excel...");
						this.workbook = XLSX.read(data, { type: "binary" });
						this.listHojas = this.workbook.SheetNames;
						this.muestraHoja = true;

						console.log(` Archivo procesado. ${this.listHojas.length} hojas detectadas`);
						this.$toast.success(`Archivo procesado: ${this.listHojas.length} hojas encontradas`);

					} catch (error) {
						console.error("❌ Error procesando Excel:", error);
						this.$toast.error("Error al procesar el archivo Excel");
					} finally {
						//  DESACTIVAR LOADER
						this.isLoading = false;
					}
				}, 100);
			};

			this.fileReader.onerror = () => {
				this.isLoading = false;
				this.$toast.error("Error al leer el archivo seleccionado");
			};

			if (selectedFile) {
				console.log(`📁 Procesando: ${selectedFile.name} (${(selectedFile.size / 1024 / 1024).toFixed(2)} MB)`);
				this.fileReader.readAsBinaryString(selectedFile);
			} else {
				this.isLoading = false;
			}
		},

		// NUEVOS MÉTODOS PARA MODAL DE CONFIRMACIÓN
		showConfirmationModal() {
			this.showConfirmModal = true;
			this.startCountdown();
		},

		startCountdown() {
			this.confirmButtonEnabled = false;
			this.countdown = 5;

			if (this.countdownInterval) {
				clearInterval(this.countdownInterval);
			}

			this.countdownInterval = setInterval(() => {
				this.countdown -= 1;
				if (this.countdown <= 0) {
					this.confirmButtonEnabled = true;
					clearInterval(this.countdownInterval);
				}
			}, 1000);
		},

		confirmAndLoad() {
			// Limpiar el intervalo
			if (this.countdownInterval) {
				clearInterval(this.countdownInterval);
			}

			// Cerrar modal de confirmación
			this.showConfirmModal = false;

			// Iniciar la carga
			this.cargaInterco();
		},

		cancelConfirmation() {
			this.showConfirmModal = false;
			if (this.countdownInterval) {
				clearInterval(this.countdownInterval);
			}
		},

		onConfirmModalHidden() {
			if (this.countdownInterval) {
				clearInterval(this.countdownInterval);
			}
		},

		formatFecha(fecha) {
			if (!fecha) return 'No seleccionada';
			const [year, month] = fecha.split('-');
			const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
				'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
			return `${meses[parseInt(month) - 1]} ${year}`;
		},

		getCompanyName() {
			if (!this.companyId) return 'No seleccionada';
			const company = this.listCompany.find(c => c.id === this.companyId);
			return company ? `${company.acronym} - ${company.nombre}` : 'No encontrada';
		},

		getFileName() {
			return this.fileName || 'No seleccionado';
		},

		async cargaInterco() {
			this.isLoading = true;
			this.isUploadCancelled = false;

			try {
				let worksheet = this.workbook.Sheets[this.selectedHoja];
				let rawData = XLSX.utils.sheet_to_json(worksheet, {
					header: 1,
					defval: ""
				});

				let listadoCuentasArray = rawData.filter(fila =>
					fila && Array.isArray(fila) && fila.length > 0
				);

				console.log('Número total de filas:', listadoCuentasArray.length);

				if (listadoCuentasArray.length === 0) {
					throw new Error('El archivo Excel está vacío');
				}

				//  NUEVA ESTRATEGIA: Enviar TODOS los datos de una vez
				await this.procesarArchivoCompleto(listadoCuentasArray);

			} catch (error) {
				console.error('Error procesando Excel:', error);
				this.$toast.error("Error procesando archivo Excel: " + error.message);
			} finally {
				this.isLoading = false;
			}
		},

		async procesarArchivoCompleto(listadoCuentasArray) {
			this.showProgressModal = true;
			this.progressMessage = 'Procesando archivo Excel...';
			this.progressPercentage = 0;
			this.processedRows = 0;
			this.totalRows = listadoCuentasArray.length;
			this.startTime = new Date();
			this.elapsedTime = '0s';

			this.progressInterval = setInterval(() => {
				this.actualizarTiempoTranscurrido();
			}, 1000);

			try {
				const formato = this.formato_interco.toString();

				let form = {
					"vigencia": this.cambFormatoVigencia(),
					"company": this.companyId,
					"listadoCuentas": listadoCuentasArray,
					"formato": formato,
					'idUser': this.$store.state.userId,
					'esCompleto': true
				}

				this.progressPercentage = 30; //  PROGRESO INICIAL
				this.progressMessage = 'Enviando datos al servidor...';

				let servicioCargue;
				switch (formato) {
					case '10': servicioCargue = Cargue.cargaIntercoF10(form); break;
					case '20': servicioCargue = Cargue.cargaIntercoF20(form); break;
					case '30': servicioCargue = Cargue.cargaIntercoF30(form); break;
					case '40': servicioCargue = Cargue.cargaIntercoF40(form); break;
					case '50': servicioCargue = Cargue.cargaIntercoF50(form); break;
					case '60': servicioCargue = Cargue.cargaIntercoF60(form); break;
					default: throw new Error(`Formato ${formato} no soportado`);
				}

				this.progressPercentage = 60; //  PROGRESO INTERMEDIO
				this.progressMessage = 'Procesando en servidor...';

				const respuesta = await servicioCargue;

				if (respuesta.status === 200) {
					this.progressPercentage = 100;
					this.processedRows = respuesta.data.filasProcesadas || listadoCuentasArray.length; //  DATOS REALES
					this.$toast.success(` ${respuesta.data.message}`);
					this.showBtnHoja = false;

					//  REFRESH DE CAMPOS AL TERMINAR EL PROCESO
					this.resetForm();
				} else {
					throw new Error(respuesta.data?.message || 'Error en el servidor');
				}

			} catch (error) {
				this.$toast.error("Error en el servidor: " + error.message);
				throw error;
			} finally {
				clearInterval(this.progressInterval); //  LIMPIAR INTERVALO
				this.showProgressModal = false;
			}
		},

		//  NUEVO MÉTODO PARA RESETEAR CAMPOS
		resetForm() {
			// Limpiar campos principales
			this.selVigencia = "";
			this.grupoId = "";
			this.companyId = "";
			this.formato_interco_asignado = false;
			this.formato_interco = '';
			this.formato_interco_nombre = '';
			this.companyName = '';

			// Limpiar campos relacionados con el archivo
			this.listHojas = [];
			this.showBtnHoja = false;
			this.muestraHoja = false;
			this.selHoja = false;
			this.selectedHoja = '';
			this.workbook = '';
			this.fileName = '';

			// Limpiar input de archivo
			const inputArch = document.getElementById("archivoExcel");
			if (inputArch) {
				inputArch.value = '';
			}

			// Resetear variables de progreso
			this.progressPercentage = 0;
			this.processedRows = 0;
			this.totalRows = 0;
			this.elapsedTime = '0s';

			console.log('Formulario reseteado exitosamente');
		},

		getProgressStage() {
			if (this.progressPercentage < 30) return 'Preparando datos';
			if (this.progressPercentage < 60) return 'Enviando al servidor';
			if (this.progressPercentage < 100) return 'Procesando en servidor';
			return 'Completado';
		},

		actualizarTiempoTranscurrido() {
			if (this.startTime) {
				const ahora = new Date();
				const segundosTranscurridos = Math.floor((ahora - this.startTime) / 1000);
				const minutos = Math.floor(segundosTranscurridos / 60);
				const segundos = segundosTranscurridos % 60;

				this.elapsedTime = minutos > 0
					? `${minutos}m ${segundos}s`
					: `${segundos}s`;
			}
		},

		cancelUpload() {
			this.isUploadCancelled = true;
			this.showProgressModal = false;
			if (this.progressInterval) {
				clearInterval(this.progressInterval);
			}
			this.$toast.info('Proceso de carga cancelado');
		},

		cambFormatoVigencia() {
			let anio = this.selVigencia.substring(0, 4)
			let mes = this.selVigencia.substring(5, 7)
			return anio + mes
		},

		f_showHoja() {
			this.showBtnHoja = true
		},
	},
	mounted() {
		this.isLoading = true;

		Promise.all([
			Company.getAllCompanies(),
			Company.getAllFormatos(),
			Grupo.getAllGrupos()
		])
			.then(([companiesResult, formatosResult, gruposResult]) => {
				this.listCompany = companiesResult.data.companies || companiesResult.data;
				this.listFormatos = formatosResult.data.formatos;
				this.listGrupos = gruposResult.data.grupos;
				this.filteredCompany = this.listCompany;

				if (this.listFormatos && this.listFormatos.length > 0) {
					this.listFormatos.forEach((formato, index) => {
						console.log(`Formato ${index}:`, {
							id_compania: formato.id_compania,
							formato: formato.formato,
							formato_interco: formato.formato_interco
						});
					});
				}
			})
			.catch((err) => {
				console.log('Error:', err);
			})
			.finally(() => {
				this.isLoading = false;
			});
	},
	beforeDestroy() {
		// Limpiar intervalos cuando el componente se destruye
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
		if (this.progressInterval) {
			clearInterval(this.progressInterval);
		}
	}
}
</script>

<style scoped>
.progress-details {
	background-color: #f8f9fa;
	padding: 15px;
	border-radius: 8px;
	margin-bottom: 15px;
}

.progress-details p {
	margin-bottom: 5px;
	font-size: 0.9rem;
}

.progress-stages {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 20px 0;
}

.stage {
	display: flex;
	flex-direction: column;
	align-items: center;
	flex: 1;
	position: relative;
}

.stage:not(:last-child)::after {
	content: '';
	position: absolute;
	top: 15px;
	left: 60%;
	width: 80%;
	height: 2px;
	background-color: #dee2e6;
	z-index: 1;
}

.stage.active:not(:last-child)::after {
	background-color: #007bff;
}

.stage-indicator {
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background-color: #dee2e6;
	color: #6c757d;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	margin-bottom: 8px;
	position: relative;
	z-index: 2;
}

.stage.active .stage-indicator {
	background-color: #007bff;
	color: white;
}

.stage-label {
	font-size: 0.8rem;
	text-align: center;
	color: #6c757d;
}

.stage.active .stage-label {
	color: #007bff;
	font-weight: bold;
}

/* NUEVOS ESTILOS PARA MODAL DE CONFIRMACIÓN */
.confirmation-info {
	background-color: #f8f9fa;
	border-radius: 8px;
	padding: 15px;
	text-align: left;
}

.confirmation-info p {
	margin-bottom: 10px;
	font-size: 1.1rem;
}

.confirmation-info p strong {
	color: #2c3e50;
	min-width: 120px;
	display: inline-block;
}

.btn-secondary:disabled {
	opacity: 0.65;
	cursor: not-allowed;
}

.alert-warning {
	background-color: #fff3cd;
	border-color: #ffc107;
	color: #856404;
	border-radius: 8px;
}

.alert-warning i {
	margin-right: 8px;
}
</style>